import {
  useMutation,
  useQuery,
  useQueryClient,
  queryOptions,
} from "@tanstack/react-query";

import {
  sharedOverallViewWithCoachFn,
  sharedGoalsOfLifeWithCoachFn,
  getUserSharedStatusFn,
  getClientSharedStatusFn,
} from "~/lib/functions/user-shared";

export const userSharedQueryKeys = {
  all: ["user-shared"] as const,
  status: () => [...userSharedQueryKeys.all, "status"] as const,
};

export const userSharedStatusQueryOptions = () =>
  queryOptions({
    queryKey: userSharedQueryKeys.status(),
    queryFn: () => getUserSharedStatusFn(),
  });

export const useUserSharedStatus = () => {
  return useQuery(userSharedStatusQueryOptions());
};

export const useShareOverallViewWithCoach = () => {
  return useMutation({
    mutationFn: (shared: boolean) =>
      sharedOverallViewWithCoachFn({ data: { shared } }),
  });
};

export const clientSharedStatusQueryOptions = (userId: string | undefined) =>
  queryOptions({
    queryKey: [...userSharedQueryKeys.all, "client-status", userId],
    queryFn: () => {
      if (!userId) {
        throw new Error("Invariant: userId is required for this query.");
      }
      return getClientSharedStatusFn({ data: { userId } });
    },
    enabled: !!userId,
  });

export const useClientSharedStatus = (userId: string | undefined) => {
  return useQuery(clientSharedStatusQueryOptions(userId));
};

export const useShareGoalsOfLifeWithCoach = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (shared: boolean) =>
      sharedGoalsOfLifeWithCoachFn({ data: { shared } }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: userSharedQueryKeys.all,
      });
    },
  });
};
